import {
  LookupStrategy,
  PackageEvaluationResponse,
} from 'types/packages-api/responses';
import style from './summary.module.scss';
import { Link } from 'components/link';
import { capitalizeFirstLetter } from 'utils/strings';
import { DefinitionTooltip } from '@carbon/react';

const formatLookupStrategy = (strategy: LookupStrategy | undefined): string => {
  if (!strategy || strategy === 'legacy') return 'Eval2.0';
  return 'Eval2.5';
};

const getLookupStrategyTooltip = (
  strategy: LookupStrategy | undefined
): string => {
  if (strategy === 'tir') {
    return 'Uses Eval 3.0 pre-computed tract intersection results with FOUCS optimization';
  }
  return 'Uses database views (best_fit_allocations, contained_wells)';
};

const Summary = ({
  data,
  isCombined,
}: {
  isCombined: boolean;
  data: PackageEvaluationResponse;
}) => {
  return (
    <div className={style.evaluationData}>
      {!isCombined && (
        <dl>
          <dt>Scenario</dt>
          <dd>
            <Link to={data.scenario.href} target="_blank">
              {data.scenario.name}
            </Link>
          </dd>
        </dl>
      )}
      <dl>
        <dt>Interest Type</dt>
        <dd>
          {isCombined
            ? 'All'
            : capitalizeFirstLetter(data.scenario.interestType)}
        </dd>
      </dl>
      <dl>
        <dt>Lookup Strategy</dt>
        <dd>
          <DefinitionTooltip
            align="bottom-start"
            definition={getLookupStrategyTooltip(data.lookupStrategy)}
          >
            {formatLookupStrategy(data.lookupStrategy)}
          </DefinitionTooltip>
        </dd>
      </dl>
    </div>
  );
};

export { Summary };
